import React, { useEffect } from 'react';
import { useFavorites } from '../utils/FavoritesContext';
import MovieCard from '../components/MovieCard';
import { Link } from 'react-router-dom';
import './Favorites.css';

const Favorites = () => {
    const { favorites } = useFavorites();

    useEffect(() => {
        document.title = 'My Favorites - MovieHub';
    }, []);

    return (
        <div className="favorites-page fade-in">
            <div className="container">
                <h1 className="page-title">My Favorites</h1>

                {favorites.length === 0 ? (
                    <div className="empty-favorites">
                        <div className="empty-icon-container">
                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                            </svg>
                        </div>
                        <h2>No favorites yet</h2>
                        <p>Start adding movies to your watchlist!</p>
                        <Link to="/" className="browse-btn">
                            Browse Movies
                        </Link>
                    </div>
                ) : (
                    <>
                        <p className="favorites-count">
                            You have {favorites.length} favorite movies
                        </p>
                        <div className="movies-grid">
                            {favorites.map((movie) => (
                                <MovieCard key={movie.imdbID} movie={movie} />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Favorites;
